import { computed, ComputedRef } from 'vue'
import { useStore } from 'vuex'

import { FreeSpaceStateModuleName } from '@/store/modules/modules'

export class FreeSpaceStateViewModel {
  private store = useStore()

  sourceCode: ComputedRef<string> = computed(() => this.store.getters[`${FreeSpaceStateModuleName}/sourceCode`])
  isErrorShow: ComputedRef<boolean> = computed(() => this.store.getters[`${FreeSpaceStateModuleName}/isErrorShow`])
  testInput: ComputedRef<string> = computed(() => this.store.getters[`${FreeSpaceStateModuleName}/testInput`])
  userOutput: ComputedRef<string> = computed(() => this.store.getters[`${FreeSpaceStateModuleName}/userOutput`])
  errorMessage: ComputedRef<string | null> = computed(
    () => this.store.getters[`${FreeSpaceStateModuleName}/errorMessage`]
  )

  setSourceCode(code: string): void {
    this.store.commit(`${FreeSpaceStateModuleName}/setSourceCode`, { code })
  }

  setIsErrorShow(isErrorShow: boolean): void {
    this.store.commit(`${FreeSpaceStateModuleName}/setIsErrorShow`, { isErrorShow })
  }

  setTestInput(input: string): void {
    this.store.commit(`${FreeSpaceStateModuleName}/setTestInput`, { input })
  }

  setErrorMessage(message: string): void {
    this.store.commit(`${FreeSpaceStateModuleName}/setErrorMessage`, { message })
  }
}
